<template>
    <div
      class="board"
     
    >
      <div class="sks"><span @click="gos">
          ＜ </span>
          整件购专区
      </div>
      <van-swipe :autoplay="3000">
        <van-swipe-item
         
        >
          <!-- <img :src="image" /> -->
          <img
            src="../../assets/jvip/01.jpg"
            alt=""
          >
        </van-swipe-item>
      
      
      </van-swipe>
   
   
      <div class="flp">
        <div class="fenl clearfix">
          
          <div
          v-for="v in classList"

            class="fenl_1"
            @click="toList1(v.id,v.name)"
          >
            <img :src="v.image" />
            <!-- <div>{{ item }}</div> -->
            <div class="">{{v.name.substring(2)}}    </div>
          </div>
        
        </div>
      </div>
      <div class="w1 wt">
        <!-- <img src="../../assets/s11/ss/00.png" alt=""> -->
        精选专区
      </div>
     <div class="wgdb">
        <div class="ws clearfix">
           
          <div 
          @click="toList2('整件生态板')" class="wsn">
              <img src="../../assets/jvip/分区01.png" alt="">
          </div>
          <div 
          @click="toList2('整件石膏板')" class="wsn">
              <img src="../../assets/jvip/分区02.png" alt="">
          </div>
          <div 
          @click="toList2('整件阻燃板')" class="wsn">
              <img src="../../assets/jvip/分区03.png" alt="">
          </div>
          <div 
          @click="toList2('整件细木工板')" class="wsn">
              <img src="../../assets/jvip/分区04.png" alt="">
          </div>
          <div 
          @click="toList2('整件欧松板')" class="wsn">
              <img src="../../assets/jvip/分区05.png" alt="">
          </div>
          <div 
          @click="toList2('整件密度板')" class="wsn">
              <img src="../../assets/jvip/分区06.png" alt="">
          </div>
          <div 
          @click="toList2('整件木方')" class="wsn">
              <img src="../../assets/jvip/分区07.png" alt="">
          </div>
          <div 
          @click="toList2('整件油漆涂料')" class="wsn">
              <img src="../../assets/jvip/分区08.png" alt="">
          </div>
          <div 
          @click="toList2('整件水泥板|硅酸钙板')" class="wsn">
              <img src="../../assets/jvip/分区09.png" alt="">
          </div>
          <div 
          @click="toList2('整件建筑模板')" class="wsn">
              <img src="../../assets/jvip/分区10.png" alt="">
          </div>
          
        </div>
      </div>
      <div class="w1">
      </div>
      <div class="tui ">
        
        <div class="more">
            整件 <span style="color: #d147ed;font-size: 0.4rem;">爆款</span> | 品牌优选
          </div>
          <div  class="content">
    
       
        <ul class="clearfix">
          <li
            v-for="v in classList1 "
            :key="v.id"
            @click="goproud(v.id,v.son_store_id,)"
           
          >
            <img
              :src="v.thumb"
              alt=""
            >
            <p
             
              class="price"
            ><span>超级VIP</span> ￥{{v.min_price}}</p>
          
            <p class="name">{{v.name}}</p>
            <p class="name shop"> {{(v.store_name)?v.store_name:''}}</p>
          </li>

        </ul>
      
      </div>
      </div>
    
      <div class="" style="height:0.5rem" ></div>
    <div class="dao" v-show="false">
      <van-count-down @finish='wanc' millisecond :time="time" format="HH:mm:ss:SS" />
    </div>
    
    </div>
  </template>
  <script>
  import Vue from 'vue'
  import { Swipe, SwipeItem, Lazyload, NoticeBar, Grid, GridItem, Popup, Button, Toast ,CountDown} from 'vant'
  import jsBridge from '../../config/jsbridge-mini.js'
  
  Vue.use(Swipe)
    .use(SwipeItem)
    .use(Lazyload, { lazyComponent: true })
    .use(NoticeBar)
    .use(Grid)
    .use(GridItem).use(Popup).use(Button).use(CountDown)
  
  export default {
    name: 'board',
    created () {
        let si=3461
        if (this.$store.state.shopid == 1) {
            si=3461
        }
        if (this.$store.state.shopid == 3) {
            si=3510
        }
        if (this.$store.state.shopid == 51) {
            si=3473
        }
        if (this.$store.state.shopid == 56) {
            si=3495
        }
        this.axios.get('listGoods', { params: { store_id: this.$store.state.shopid, class_id: si, class_name:'整件购'} }).then(res => {
           this.classList = res.data.data.threeClass
           this.classList1 = res.data.data.recommend.sort((a, b) => a.gsort - b.gsort)
        }).catch(ref => { })
       
    },
    data () {
      return {
        value: '',
        show: false,
        images: [1, 2],
        searchBarFixed: false,
        navSwitch: 1,
        number: -1,
        str: '',
        ad: [],
        classList: [],
        classList1: [],
        screenType: 'zonghe',
        productList: [],
        isEnd1: true,
        deswiper: '',
        login: sessionStorage.getItem('login'),
        isEnd: false, //判断是否为最后一页
        params: {
          page: 1,
          id: '',
          sort_field: 'sort',
          class_three: '',
          sort_type: '',
        },
        screenState: 1,
        totalHeight: 0,
  
        statusNav: 1,
        id: 157,
        fg:false,
        time:0,
      }
    },
    props: {
    },
    computed: {
  
    },
    watch: {
  
    },
   
    mounted () {
  
    },
    methods: {
      gos () {
        this.$router.push("/")
      },
      go () {
        // Toast('正在努力备货中~')
        let ab=0
   if(this.$store.state.shopid==1){
              ab=2430
          }else{
            return
          }
           if(this.$store.state.shopid==3){
              ab=265
          }
           if(this.$store.state.shopid==51){
              ab=1108
          }
       
          this.$router.push({
            name: 'products11',
            query: {
              id: ab
            }
          })
        
      },
      getClientHeight () {
  
      },
  
  
      enterDetail (goods) {
        return false
        this.$router.push({
          name: 'product',
          params: {
            id: goods.id,
            status: 1,
          },
        })
      },
      toList (id,name) {
        // return false
        let ac=''
        if(id==1){
            if(this.$store.state.shopid==1){
              ac=16
          }
           if(this.$store.state.shopid==3){
              ac=265
          }
           if(this.$store.state.shopid==51){
              ac=1108
          }
          if(this.$store.state.shopid==56){
              ac=1204
          }
        }else if(id==2){
          if(this.$store.state.shopid==1){
              ac=19
          }
           if(this.$store.state.shopid==3){
              ac=294
          }
           if(this.$store.state.shopid==51){
            ac=1189
          }
          if(this.$store.state.shopid==56){
              ac=2566
          }
            
        }else if(id==3){
          if(this.$store.state.shopid==1){
              ac=2766
          }
           if(this.$store.state.shopid==3){
              ac=269
          }
           if(this.$store.state.shopid==51){
            ac=3356
          }
          if(this.$store.state.shopid==56){
              ac=3193
          }
            
        }else if(id==4){
          if(this.$store.state.shopid==1){
              ac=170
          }
           if(this.$store.state.shopid==3){
              ac=268
          }
           if(this.$store.state.shopid==51){
            ac=1114
           }
           if(this.$store.state.shopid==56){
              ac=1026
          }
        }else if(id==5){
          if(this.$store.state.shopid==1){
              ac=167
          }
           if(this.$store.state.shopid==3){
              ac=267
          }
           if(this.$store.state.shopid==51){
            ac=1111
           }
           if(this.$store.state.shopid==56){
              ac=1025
          }
        }else if(id==6){
          if(this.$store.state.shopid==1){
              ac=219
          }
           if(this.$store.state.shopid==3){
              ac=616
          }
           if(this.$store.state.shopid==51){
            ac=0
           }
            
        }else if(id==7){
          if(this.$store.state.shopid==1){
              ac=179
          }
           if(this.$store.state.shopid==3){
              ac=270
          }
           if(this.$store.state.shopid==51){
            ac=1113
           }
           if(this.$store.state.shopid==56){
              ac=1028
          }
        }else if(id==8){
          if(this.$store.state.shopid==1){
              ac=216
          }
           if(this.$store.state.shopid==3){
              ac=400
          }
           if(this.$store.state.shopid==51){
            ac=0
           }
            
        }else if(id==9){
          if(this.$store.state.shopid==1){
              ac=20
          }
           if(this.$store.state.shopid==3){
              ac=295
          }
           if(this.$store.state.shopid==51){
            ac=1116
           }
            
        }else if(id==10){
          if(this.$store.state.shopid==1){
              ac=214
          }
           if(this.$store.state.shopid==3){
              ac=1918
          }
           if(this.$store.state.shopid==51){
            ac=1327
           }
            
        }else if(id==11){
          if(this.$store.state.shopid==1){
              ac=195
          }
           if(this.$store.state.shopid==3){
              ac=1180
          }
           if(this.$store.state.shopid==51){
            ac=1922
           }
           if(this.$store.state.shopid==56){
              ac=1824
          }
        }else if(id==12){
          if(this.$store.state.shopid==1){
              ac=191
          }
           if(this.$store.state.shopid==3){
              ac=397
          }
           if(this.$store.state.shopid==51){
            ac=1118
           }
           if(this.$store.state.shopid==56){
              ac=1214
          }
            
        }else if(id==13){
          if(this.$store.state.shopid==1){
              ac=521
          }
  
           if(this.$store.state.shopid==3){
              ac=400
          }
           if(this.$store.state.shopid==51){
            ac=1182
          }
          if(this.$store.state.shopid==56){
              ac=3257
          }
        }else if(id==16){
          if(this.$store.state.shopid==1){
              ac=1953
          }
  
           if(this.$store.state.shopid==3){
              ac=400
          }
           if(this.$store.state.shopid==51){
            ac=1955
          }
          if(this.$store.state.shopid==56){
              ac=1957
          }
        }
      this.$store.state.pid = ac
      this.$store.state.spid=0
        this.$store.state.spid1=""
        this.$router.push({ name: 'brandproducts11', query: { id:ac,name } })
        
        },
        toList1 (id,name) {
        this.$router.push({ name: 'zhengp', query: { id,name } })
            
        },
        toList2 (name) {
            this.classList.forEach(v=>{
                if(v.name==name){
                    this.$router.push({ name: 'zhengp', query: { id:v.id,name } })

                }
            })
        },
        goproud (id,s) {
      // console.log(s)
    
      this.$router.push({ name: 'product', query: { id } })
 
      return
    },
      active (i) {
        this.params.class_three = i
        this.navSwitch = 1
        this.productList = []
        this.params.page = 1
        this.isEnd = false
        this.getProductList()
      },
      getProductList () {
  
      },
      getClassList () {
  
      },
      wanc(){
          this.fg=false
      }
    },
  
    destroyed () { },
    updated () { },
    components: {},
  }
  </script>
  
  
  <style lang="less" scoped>
  .w1{
    // width: 80%;
    margin: 0 auto;
    padding-top: 0.4rem;
    background-color: #630aa4;
  
  }
  .wt{
    text-align: center;
    color: #fff;
    letter-spacing: 3px;
    font-size: 0.45rem;
    font-weight: 600;
  }
  .w2{
    padding:  0.2rem;
  }
  .mi {
    padding: 0.5rem;
    text-align: center;
  
    p {
      font-size: 0.5rem;
      margin: 0.5rem;
    }
    input {
      height: 1rem;
      width: 70%;
      border-radius: 5%;
      font-size: 0.4rem;
    }
    margin-bottom: 1rem;
  }
  .sks {
    width: 100%;
    z-index: 99;
    height: 1.2rem;
    background-color: #630aa4;
    text-align: center;
    font-size: 0.4rem;
    line-height: 1.2rem;
    position: fixed;
    top: 0;
    left: 0;
    color: #fff;
    //   margin-top: 0.5rem;
    // position: fixed;
    // top: 0;
    // z-index: 99;
    // width: 100%;
    span {
      width: 1rem;
      position: absolute;
      left: 0;
      font-size: 0.5rem;
    }
  }
  .sp {
    width: 100%;
    height: 5.4rem;
    overflow: hidden;
  }
  .sp::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  .pad {
  //   height: 0.2rem;
  // position: relative;
  // bottom: 0.2rem;
  padding: 0.4rem 0.2rem 0 0.2rem;
  
  //   background-color: #ff1d1e;
  }
  
  
  
  .wgdb {
  
  padding: 0 0.2rem;
    // position: relative;
    // bottom: 1.8rem;
    .ws{
    z-index: 2;
  // border: 1px solid #f7f4ad;
  border-radius: 0.1rem;
      padding-top:0.5rem;
      // background-color: #fff;
      
      .wsn{
          float: left;
          width: 50%;
          padding: 1%;
          img{
              width: 100%;
          }
      }
    }
    .wgdb1{
      padding: 0.5rem 0.2rem;
       background-color: rgba(79, 77, 77, 0.324);
  padding-top: 1rem;
      }
      .more{
        text-align: center;
        font-size: 0.54rem;
        color: white;
        line-height: 2rem;
      }
  }
  
  
  
  .hot{
      //  position: relative;
          padding: 0.2rem;
  background-color: #630aa4;
          // bottom: 1rem;
          .sd{
              height: 0.2rem;
          }
      .top{
          // width: 30%;
          height: 1rem;
          img{
              width: 1.5rem;
              float: left;
          }
          p{
              color: #fff;
              font-size: 0.5rem;
              line-height: 0.6rem;
              padding-left: 1.7rem;
          }
      }
  }
  
  .dao{
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #fff;
      z-index: 99;
  }
  .guod{
    position: relative;
    .dian{
      width: 100%;
      height: 2.2rem;
      // background-color: #f99;
      position: absolute;
      bottom: 0.2rem ;
    }
  }
  .board {
    padding-top:1.1rem;
    // 轮播
    overflow-x: hidden;
    //   padding-top: 0.8rem;
    background-color: #630aa4;
    .mint-swipe {
      width: 100%;
      height: 3.28rem;
  
      .mint-swipe-items-wrap {
        width: 100%;
        height: 3.28rem;
  
        .mint-swipe-item {
          width: 100%;
          height: 3.28rem;
  
          .board-banner-img {
            width: 100%;
            height: 3.28rem;
            background-size: 100%;
          }
        }
      }
    }
    .flp {
      background-color: #630aa4;
      padding: 0 0.2rem;
      padding-top: 0.4rem;
      position: relative;
      // bottom: 2rem;
        
    }
    .fenl {
    //   background: url(../../assets/s11/ss/05.png) no-repeat center;
    //  background-size: 100% 100%;
    background-color: #fff;
    border-radius: 0.5rem;
     min-height: 5rem;
      // margin: 0 0.2rem;
      p {
        height: 0.75rem;
        line-height: 0.5rem;
        font-weight: 700;
        font-size: 0.3rem;
      }
      // background: #fff;
      padding: 0 0.3rem;
      padding-top: 0.5rem;
      text-align: center;
      box-sizing: border-box;
  
      .fenl_1 {
        width: 20%;
        text-align: center;
        float: left;
        margin-bottom: 0.45rem;
  
        img {
          width: 1.4rem;
          height: 1.5rem;
          border-radius: 5px;
          margin: 0 auto;
        }
  
        div {
          color: #333;
          font-size: 0.26rem;
          margin-top: 0.12rem;
        }
      }
    }
  .sz{
      // display: flex;
      position: relative;
      // bottom: 1.5rem;
  padding: 0 0.2rem;
  padding-top: 1rem;
  z-index: 22;
      .szn{
          float: left;
          width: 33.3%;
          margin: 0 auto;
         
      }
  }
    .mt {
      margin-top: 10px;
    }
  
    .scrolltop {
      position: fixed;
      width: 100%;
      top: 0;
      z-index: 1000;
      margin-top: 0;
    }
  
    .board_imglist {
      background: #fff;
      margin-top: 1px;
      padding: 0.21rem;
      padding-top: 0.26rem;
      padding-bottom: 0.45rem;
  
      .board_img:nth-child(odd) {
        float: left;
        width: 48.5%;
      }
  
      .board_img:nth-child(even) {
        float: right;
        width: 48.5%;
      }
  
      .board_img {
        height: 5rem;
  
        .title {
          height: 0.6rem;
        }
  
        div:first-child {
          img {
            width: 100%;
            height: 3.2rem;
          }
        }
  
        div:nth-child(2) {
          margin-top: 0.16rem;
  
          span.sp1 {
            color: #a22d2b;
            font-size: 0.26rem;
            border: 1px solid #a22d2b;
            padding: 0.02rem 0.05rem;
            border-radius: 0.05rem;
          }
  
          span.sp2 {
            color: #333;
            font-size: 0.26rem;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            width: 100%;
          }
        }
  
        div:last-child {
          margin-top: 0.16rem;
  
          span:first-child {
            color: #a22d2b;
            font-size: 0.26rem;
          }
  
          /*span:last-child {*/
          /*line-height: 0.2rem;*/
          /*color: #999;*/
          /*font-size: .26rem;*/
          /*text-decoration: line-through*/
          /*}*/
        }
      }
    }
  }
  .tui{
    background-color: #fff;
    // height: 5.5rem;
    padding-top: 0.3rem;
    .more{ 
        text-align: center;
        font-size: 0.4rem;
    }
    .content {
    flex: 1;
    padding:0.2rem;
    .title {
      text-align: center;
      font-size: 0.4rem;
      height: 1rem;
    }
    ul {
      li {
        float: left;
        width: 46%;
        // padding: 0.266667rem 0.01rem 0.1rem 0.533333rem;
        // padding-left: 0.1rem;
        // padding-right: 0.1rem;
        height: 5.3rem;
        margin-left: 0.1rem;
        margin: 0.2rem 0.15rem 0.3rem 0.2rem;
        img {
          width: 4.29rem;
          height: 4.2rem;
        }
        .price {
          height: 0.9rem;
          line-height: 0.9rem;
          font-size: 0.4rem;
          font-weight: 700;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          span {
            font-weight: normal;
            color: #fff;
            background-color: #482e04;
            padding: 0.1rem 0.2rem;
            border-radius: 0.3rem;
          }
        }
        .name {
          color: #9f9f9f;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .shop{
          padding-top: 0.1rem;
          // color: rgb(239, 81, 81);
        }
      }
    }
  }
  }
  </style>
  